import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import PatientEngagement from 'containers/PatientEngagement';
import PageLoader from 'components/PageLoading';

const PatientEngagementIndex = ({ loading, getData, isData }) => {
  useEffect(() => {
    if (!loading && !isData) {
      getData();
    }
  });

  if (loading || !isData) {
    return <PageLoader />;
  }

  return <PatientEngagement />;
};

PatientEngagementIndex.propTypes = {
  getData: PropTypes.func.isRequired,
  loading: PropTypes.bool.isRequired,
  isData: PropTypes.bool.isRequired,
};

export default PatientEngagementIndex;
